import React from 'react';
import {Card, Col, Row} from "react-bootstrap";
import "../../layout/styles/components/CardView.scss"

const DashCardView = ({
                        propDate = '',
                        propText2 = '화재발생 없음',
                        propLength
                      }) => {
  return (
      <Card
          bg={'dark'}
          key={'dark'}
          border="light"
          className={`${propLength === 1 ? "h-100" : propLength === 2 ? "h-50" : propLength === 3 ? "h-33" : ''} my-auto`}
      >
        <Card.Body className={'text-center'}>
          <Row className={`d-flex align-items-center
          ${propLength === 1 || propLength === 2 || propLength === 3 ? "h-100" : ''}`}
          >
            <Col md={12} className={"fs-3 my-auto"}>
              {propDate}
            </Col>
            <Col md={12} className={"fs-2 fw-bold my-auto text-danger"}>
              {propText2}
            </Col>
          </Row>
        </Card.Body>
      </Card>
  );
};

export default DashCardView;